var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"ratingContainer",staticClass:"rate-user",on:{"click":function($event){$event.stopPropagation();return _vm.handleRate($event)}}},[_c('Rating',{attrs:{"rating":_vm.rating || 0}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }